// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-614ffe70]{border-radius:50%;margin:auto;vertical-align:middle;width:24px;height:24px}.v-menu__content[data-v-614ffe70]{max-height:1000px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
